import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { CheckboxGroup, Checkbox } from '@availity/form';
import { Button, Label } from 'reactstrap';
import { Navigate } from 'react-router-dom';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import housingstore from '../stores/housingstore';
import ProgressValidatedForm from '../../Common/components/ProgressValidatedForm';
import withNavigate from '../../Common/components/withNavigate';

@observer
class HealthNeeds extends Component {

  constructor(props) {
    super(props);

    this.state = {
      redirectToRiskFactors: false,
      redirectToMemberInfo: false,
    }

    if(window.performance) {
			if(performance.navigation.type == 1) {
        housingstore.resetSupportiveHousingPage();
				window.location.href = '#';
			}
		}
  }

  componentWillMount() {
    if (housingstore.getSupportiveHousingRouteStatus('/') !== 'completed') {
      housingstore.resetSupportiveHousingPage();
      housingstore.resetSupportiveHousingRoutesStatus();
      this.setState({ redirectToMemberInfo: true });
    } else if (
      housingstore.getSupportiveHousingRouteStatus('/healthneeds') !== 'completed' &&
      housingstore.getSupportiveHousingRouteStatus('/healthneeds') !== 'active'
    ) {
      housingstore.setSupportiveHousingPageStatus('#healthneeds', 'active');
      housingstore.setSupportiveHousingRouteStatus('/healthneeds', 'active');
    }
  }

  componentDidMount() {

    window.onpopstate = () => {
      this.props.navigate(1); 
    }
  }

  selectHealthNeeds = value => {
    housingstore.setHealthNeedCat(value);
  }

  goBack = () => {
    housingstore.setSupportiveHousingPageStatus('#healthneeds', 'disabled');
    housingstore.setSupportiveHousingRouteStatus('/healthneeds', 'inactive');
    housingstore.setSupportiveHousingPageStatus('#', 'active');
    housingstore.setSupportiveHousingRouteStatus('/', 'active');
    this.setState({redirectToMemberInfo: true});
  }

  submit = (pendingRoute = '/riskfactors') => {
    housingstore.setSupportiveHousingPageStatus('#healthneeds', 'active');
    housingstore.setSupportiveHousingRouteStatus('/healthneeds', 'completed');
    if (pendingRoute === '/riskfactors') {
      this.setState({redirectToRiskFactors: true});
      return;
    }
    this.props.navigate(pendingRoute);
  }

  render() {
    const { redirectToRiskFactors, redirectToMemberInfo } = this.state;
    
    const { healthNeedCat, supportiveHousingPagesAHAH, supportiveHousingPagesNoAHAH, memberInfo } = housingstore;

    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;

    const supportiveHousingPages = (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes' ? supportiveHousingPagesAHAH : supportiveHousingPagesNoAHAH);

    if(redirectToMemberInfo) {
      return <Navigate to="/" />
    }

    if(redirectToRiskFactors) {
      return <Navigate to="/riskfactors" />
    }


    return (
      <>
        <div className="border-form">
          <div className='spacer-50' />

          <ProgressValidatedForm
            pages={supportiveHousingPages}
            initialValues={{
              healthneedsCheck: healthNeedCat.map(x => x)
            }}
            onSubmit={this.submit}
            validationSchema={yup.object().shape({
              healthneedsCheck: yup.array()
              .isRequired(true, 'Please select an option before continuing!')
              .typeError('Please select an option before continuing!')
            })}
          >
            <small className="required-fields">*required fields</small>
            <div className="spacer-40" />
            <h2 className="poppinsH2">
              Complex needs eligibility requirements
            </h2>
            <div className="spacer-24" />
            <em>
              <small className="label-font">Information in this section is required in order to determine eligibility for supportive housing services.</small>
            </em>
            <div className="spacer-48" />
            <div className="d-flex">
              <h5 className="poppinsH5">
                Health Needs*
              </h5>
              <p className="selectText">
                (must select at least one)
              </p>
            </div>
            <div className="spacer-48" />
            <Label className="criteria-header" htmlFor="healthneedsCheck">
              The client meets one of the following criteria:
            </Label>
            <div className="label-spacer-24" />
            <CheckboxGroup name="healthneedsCheck" value={healthNeedCat} onChange={this.selectHealthNeeds}>
              <Checkbox 
                label="Mental health need where there is a need for improvement, stabilization or prevention of deterioration to functioning resulting from the presence of a mental illness (as determined by a licensed behavioral health agency)"
                name="mentalHealthOpt"
                id="mentalHealthOpt"
                className="label-font mb-23 no-display"
                groupName="healthneedsCheck"
                value="opt1"
              />
              <div className="mt-3" />
              <Checkbox 
                label="Diagnosed with a substance use disorder (SUD), by meeting a one or higher level on the American Society of Addiction Medicine (ASAM) Criteria (as determined by a licensed behavioral health agency)"
                name="diagnosedSubstanceOpt"
                id="diagnosedSubstanceOpt"
                className="label-font mb-23 no-display"
                groupName="healthneedsCheck"
                value="opt2"
              />
              <div className="mt-3" />
              <Checkbox
                label="Needs assistance with three or more activities of daily living (ADL) or one or more hands-on ADL as determined by a Comprehensive Assessment and Reporting Evaluation (CARE)"
                name="needsAssistanceOpt"
                id="needsAssistanceOpt"
                className="label-font mb-23 no-display"
                groupName="healthneedsCheck"
                value="opt3"
              />
              <div className="mt-3" />
              <Checkbox
                className="label-font mb-23 no-display"
                label={`The client is a homeless individual with a disability, determined by a coordinated entry assessment. (Individual assessed to have a complex health need, 
                  which is defined as a long continuing or indefinite physical condition requiring improvement, stabilization or prevention of deterioration of functioning, 
                  including ability to live independently without support.)`}
                name="homelessDisabilityOpt"
                id="homelessDisabilityOpt"
                value="opt4"
              />
            </CheckboxGroup>
            <div className="spacer-50" />
            <Button type="button" color={"primary"} className={'btn btn-primary buttonBack'} onClick={this.goBack}>
              Back
            </Button>
            <Button type="submit" color={"primary"} className={'btn btn-primary nextBtn'}>
              Next
            </Button>
          </ProgressValidatedForm>
        </div>
        <div className="pb-spacerRem-4" />
      </>
    );
  }
}

export default withNavigate(HealthNeeds);

HealthNeeds.propTypes = {
  navigate: PropTypes.func
};